import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '@/views/Home.vue'
import QuemSomos from '@/views/QuemSomos.vue'
import Cursos from '@/views/Cursos.vue'
import Noticias from '@/views/Noticias.vue'
import Contato from '@/views/Contato.vue'
import LoginVue from '@/views/Login.vue'
import ViewNoticia from '@/components/ViewNoticia.vue'
import { AuthStore } from '@/stores/Auth.js'
import { toastr } from '@/plugins/toast.js'

/**
* Componentes de administração
*/
import ListaUsuarios from '@/views/admin/ListaUsuarios.vue'
import CadastrarNoticia from '@/views/admin/CadastrarNoticia.vue'
import CadCategoriasNoticiasVue from '@/views/admin/CadCategoriasNoticias.vue'
import CadFinancasFormaPagamentoVue from '@/views/admin/CadFinancasFormaPagamento.vue'
import CadFinancasReceitasVue from '@/views/admin/CadFinancasReceitas.vue'
import CadParceiros from '@/views/admin/CadParceiros.vue'

/**
 * Componentes de usuarios multiplicadores
*/
import MinhasIndicacoes from '@/views/multiplicador/MinhasIndicacoes.vue'

/**
 * Usuários gerais
*/
import MeusDadosVue from '@/views/usuarios/MeusDados.vue'

/**
 * Telas de mensagens
 */
import Temporaria from '@/views/Temporaria.vue'
import SemAcessoMultiplicadorVue from '@/views/SemAcessoMultiplicador.vue'
import CadFinancasCategoriaDespesaVue from '@/views/admin/CadFinancasCategoriaDespesa.vue'
import CadFinancasDespesasVue from '@/views/admin/CadFinancasDespesas.vue'
import CadCursosVue from '@/views/admin/CadCursos.vue'
import CadCursosAulasVue from '@/views/admin/CadCursosAulas.vue'
import FinancasVue from '@/views/lider/Financas.vue'
import MeusPagamentosVue from '@/views/mais/MeusPagamentos.vue'
import Parceiro from '@/views/Parceiro.vue'
import ConfigGeral from '@/views/admin/ConfigGeral.vue'
import RecuperarSenha from '@/views/RecuperarSenha.vue'
import ConfirmarCodigo from '@/views/ConfirmarCodigo.vue'
import AlterarSenha from '@/views/AlterarSenha.vue'
import { forEach } from 'jszip'
import { muda_titulo } from '@/assets/js/functions'

const acesso_master = ['1'];
const acesso_admin = ['1', '2'];
const acesso_multiplicador = ['1', '2', '3', '4', '5'];
const acesso_mais = ['1', '2', '3', '4'];
const acesso_lider = ['1', '2', '3'];

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/cadastro/:cod',
    name: 'homeCadastro',
    component: HomeView
  },
  {
    path: '/quem-somos',
    name: 'QuemSomos',
    // meta: {
    //   title: 'Quem somos'
    // },
    component: QuemSomos
  },
  {
    path: '/cursos',
    name: 'Cursos',
    component: Cursos,
    meta: {
      auth: true
    }
  },
  {
    path: '/cursos/:pag',
    name: 'CursosPag',
    component: Cursos,
    meta: {
      publicRoute: true,
      title: 'Login | ${process.env.VUE\_APP\_NAME}\ ',
      metaTags: [
        {
          name: 'description',
          content: 'A página de login tem uma descrição, talvez.'
        },
        {
          property: 'og:description',
          content: 'A página de login tem uma descrição de gráfico aberto, também, talvez.'
        }
      ]
    }
  },
  {
    path: '/noticias',
    name: 'Noticias',
    component: Noticias
  },
  {
    path: '/noticias/:pag',
    name: 'NoticiasPag',
    component: Noticias
  },
  {
    path: '/noticias/cat/:cat/:pag',
    name: 'NoticiasCategoria',
    component: Noticias
  },
  {
    path: '/noticias/lnk/:link',
    name: 'NoticiasDetail',
    component: ViewNoticia
  },
  {
    path: '/contato',
    name: 'Contato',
    component: Contato
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginVue
  },
  {
    path: '/recuperar_senha',
    name: 'RecuperarSenha',
    component: RecuperarSenha
  },
  {
    path: '/confimrar_codigo',
    name: 'ConfirmarCodigo',
    component: ConfirmarCodigo
  },
  {
    path: '/alterar_senha',
    name: 'AlterarSenha',
    component: AlterarSenha
  },
  /**
   * Rotas da administração
   */
  {
    path: '/meusdados',
    name: 'Meusdados',
    component: MeusDadosVue,
    meta: {
      auth: true
    }
  },
  {
    path: '/admin/lista_usuarios',
    name: 'Listuser',
    component: ListaUsuarios,
    meta: {
      auth: true,
      access: acesso_admin
    }
  },
  {
    path: '/admin/cad_categoria_noticia',
    name: 'Cad_categoria_noticia',
    component: CadCategoriasNoticiasVue,
    meta: {
      auth: true,
      access: acesso_admin
    }
  },
  {
    path: '/admin/cad_noticia',
    name: 'Cad_noticia',
    component: CadastrarNoticia,
    meta: {
      auth: true,
      access: acesso_admin
    }
  },
  {
    path: '/admin/cad_financas_forma_pagamento',
    name: 'Cad_financasFormaPagamento',
    component: CadFinancasFormaPagamentoVue,
    meta: {
      auth: true,
      access: acesso_master
    }
  },
  {
    path: '/admin/cad_financas_categoria_despesa',
    name: 'CadFinancasCategoriaDespesa',
    component: CadFinancasCategoriaDespesaVue,
    meta: {
      auth: true,
      access: acesso_master
    }
  },
  {
    path: '/admin/cad_financas_despesas',
    name: 'CadFinancasDespesas',
    component: CadFinancasDespesasVue,
    meta: {
      auth: true,
      access: acesso_master
    }
  },
  {
    path: '/admin/cad_financas_receitas',
    name: 'CadFinancasReceitas',
    component: CadFinancasReceitasVue,
    meta: {
      auth: true,
      access: acesso_master
    }
  },
  ///////////////// Parceiros - Ini ///////////////////
  {
    path: '/admin/parceiros',
    name: 'Parceiros',
    component: CadParceiros,
    meta: {
      auth: true,
      access: acesso_admin
    }
  },
  {
    path: '/parceiro/:id',
    name: 'ParceiroPag',
    component: Parceiro
  },
  ///////////////// Parceiros - Fim ///////////////////

  ///////////////// Cursos - Ini ///////////////////
  {
    path: '/admin/cad_cursos',
    name: 'Cad_cursos',
    component: CadCursosVue,
    meta: {
      auth: true,
      access: acesso_admin
    }
  },
  {
    path: '/admin/cad_aulas_curso/:id_curso',
    name: 'Cad_aulascursos',
    component: CadCursosAulasVue,
    meta: {
      auth: true,
      access: acesso_admin
    }
  },
  ///////////////// Cursos - Fim ///////////////////
  {
    path: '/mult/indicacoes',
    name: 'Indicacoes',
    component: MinhasIndicacoes,
    meta: {
      auth: true,
      access: acesso_multiplicador
    }
  },
  {
    path: '/admin/financeiro',
    name: 'Financeiro',
    component: FinancasVue,
    meta: {
      auth: true,
      access: acesso_mais
    }
  },
  {
    path: '/admin/conf_gerais',
    name: 'ConfGerais',
    component: ConfigGeral,
    meta: {
      auth: true,
      access: acesso_admin
    }
  },
  {
    path: '/meuspagamentos',
    name: 'MeusPagamentos',
    component: MeusPagamentosVue,
    meta: {
      auth: true,
      access: acesso_mais
    }
  },
  {
    path: '/acesso_restrito',
    name: 'AcessoRestrito',
    component: SemAcessoMultiplicadorVue,
    meta: {
      auth: true
    }
  },
  {
    path: '/upgrade/5',
    name: 'Upgrade6',
    component: SemAcessoMultiplicadorVue,
    props: {
      titulo: 'Upgrade de acesso',
      texto: 'Para se tornar um "Eleitor Multiplicador", você deve fazer o curso de preparo e depois fazer o teste de qualificação<br>',
    },
    meta: {
      auth: true
    }
  },
  {
    path: '/upgrade/4',
    name: 'Upgrade5',
    component: SemAcessoMultiplicadorVue,
    props: {
      titulo: 'Upgrade de acesso',
      texto: 'Para se tornar um "Eleitor +", você deve fazer o curso de preparo, realizar o teste de qualificação e fazer uma contribuição para o projeto a partir de R$ 10,00 mensais para ter acesso ao acompanhamento de toda verba investida no projeto de outros colaboradores, além de ver onde está sendo investido cada centavo.<br>',
    },
    meta: {
      auth: true
    }
  },
  {
    path: '/upgrade/3',
    name: 'Upgrade4',
    component: SemAcessoMultiplicadorVue,
    props: {
      titulo: 'Upgrade de acesso',
      texto: 'Para se tornar um "Eleitor lider", você deve fazer o curso de preparo e depois fazer o teste de qualificação, ter pelo menos 500 pessoas abaixo do seu nível<br>',
    },
    meta: {
      auth: true
    }
  },
  // {
  //   path: '/pedidos',
  //   name: 'Pedidos',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "pedidos" */ '../views/Pedidos.vue')
  // }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  if (to.meta?.auth) {
    const auth = AuthStore();
    if (auth.token && auth.user) {
      const load = document.querySelector("#load");
      load.classList.remove('d-none')
      const isAuth = await auth.checkToken()
      if (isAuth) {
        if (to.meta?.access) {
          if (to.meta?.access.includes(isAuth.type_access)) {
            next()
          } else {
            toastr.erro("Você não tem permissão para acessar esse caminho.");
            next({
              name: from.name
            })
          }
        }
        next()
      } else {
        auth.clear()
        next({ name: 'Login' })
      }
      load.classList.add('d-none')
    } else {
      setTimeout(() => {
        toastr.erro("Precisa estar logado para acessar esse link.");

      }, 200);
      auth.clear()
      next({ name: 'Login' })

    }
  } else {
    next()
  }
  var metaInfo = to.matched[0].components.default.metaInfo
  // console.log(to);
  // console.log("metaInfo.title =" + metaInfo.title);
  // console.log(metaInfo);

  if (metaInfo) {
    muda_titulo(metaInfo)
  }
  // document.title = (metaInfo != undefined ? metaInfo.title + ' | ' : '') + process.env.VUE_APP_nome_site
  // if (metaInfo) {
  //   metaInfo.meta.forEach(element => {
  //     const metaElement = document.querySelector('meta[name="' + element.name + '"]');
  //     if (metaElement) {
  //       metaElement.remove();
  //     }

  //     const metaItem = document.createElement('meta');
  //     metaItem.setAttribute('property', element.name);
  //     metaItem.setAttribute('content', element.content);
  //     document.head.prepend(metaItem);
  //   });
  // }
  window.scrollTo(0, 0);
})

export default router
